import type { SystemSettingsState } from "Interfaces";
import { Languages } from "Data/Objects/Languages";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "Data/Redux/Store";

const initialState: SystemSettingsState = {
	language: Languages.ENGLISH
};

export const setLanguageReducer = (state: SystemSettingsState, action: PayloadAction<Languages>) => {
	state.language = action.payload;
};

export const getLanguage = (state: SystemSettingsState) => {
	return state.language;
};

const languageSlice = createAppSlice({
	name: "language",
	initialState,
	reducers: {
		setLanguageAction: setLanguageReducer
	},
	selectors: {
		selectLanguage: getLanguage
	}
});

export default languageSlice;

export const { setLanguageAction } = languageSlice.actions;
export const { selectLanguage } = languageSlice.selectors;
